import "select2/dist/css/select2.min.css";
import "../scss/app.scss";

import { initTheme } from "./core/theme";
import { initRevealOnScroll } from "./core/reveal-on-scroll";
import { initHeaderShell } from "./core/header-shell";
import { initHeader } from "./components/header";
import { initHomePage } from "./pages/home";
import { initToolsPage } from "./pages/tools";
import { initImageConverterPage } from "./pages/image-converter";
import { initSqlToEntityPage } from "./pages/sql-to-entity";
import { initHtmlEditorPage } from "./pages/html-editor";
import { initJsonViewerPage } from "./pages/json-viewer";
import { initColorToolsPage } from "./pages/color-tools";
import { initQrGeneratorPage } from "./pages/qr-generator";
import { initJsonToCSharpPage } from "./pages/json-to-csharp";
import { initBase64ImagePage } from "./pages/base64-image";
import { initLanguageDrawer } from "./core/language-drawer";
import { initViwoAccordions } from "./core/viwo-accordion";
import { initViwoSelects } from "./core/viwo-select";
import { initViwoTabs } from "./core/viwo-tabs";
import { initViwoFileDrops } from "./core/viwo-file-drop";
import { initViwoFloatingLabels } from "./core/viwo-floating-label";
import { initViwoColorPickers } from "./core/viwo-color-picker";
import { initPasswordGeneratorPage } from "./pages/password-generator";
import { initTextEncoderDecoderPage } from "./pages/text-encoder-decoder";
import { initHtmlToTextPage } from "./pages/html-to-text";
import { initCssScssOptimizerPage } from "./pages/css-scss-optimizer";

window.$ = window.jQuery = $;


document.addEventListener("DOMContentLoaded", async () => {
    initTheme();

    initHeader();
    initHeaderShell();
    initRevealOnScroll();
    initLanguageDrawer();

    initHomePage();
    initToolsPage();
    initImageConverterPage();

    await initSqlToEntityPage();
    await initHtmlEditorPage();
    await initJsonViewerPage();
    await initColorToolsPage();

    initPasswordGeneratorPage();
    initTextEncoderDecoderPage();
    initHtmlToTextPage();

    initQrGeneratorPage();
    initJsonToCSharpPage();
    initBase64ImagePage();
    initCssScssOptimizerPage();

    initViwoAccordions();
    initViwoTabs();
    initViwoFileDrops();
    await initViwoSelects();
    initViwoFloatingLabels();
    initViwoColorPickers();

    document.addEventListener("viwo:tab-changed", event => {
        initViwoFloatingLabels(event.target);
        initViwoColorPickers(event.target);
    });
});